import { API_URL } from "config";
import Http from "util/https";
import { ItemInfo } from "../types/index";

async function getItemList() {
  // const http = await Http.default.useCognitoAuth();
  const http = await Http.default;
  const url = `${API_URL}/items`;
  const res = await http.get<ItemInfo>(url);
  return res.data;
}
export default getItemList;